import _ from 'lodash';
import { useState, useEffect } from 'react';
import { gql } from '@apollo/client';

import { useEdeLazyQuery, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';
import { EdeMemberType } from 'routes/marketplace-ede/types/ede/edeMember';

import { mapIssues } from '../../utils/issues';

const useGetIssuesQuery = () => {
  const queryName = useEdeQueryName('GET_ISSUES');

  const GET_ISSUES_QUERY = gql`
    query Issues($appID: ID!) {
      ${queryName} (appID: $appID) {
        dmi
        svi
        notices
      }
    }
  `;

  return useEdeLazyQuery(GET_ISSUES_QUERY);
};

export const useGetIssues = (appID: string, members: Array<EdeMemberType>) => {
  const getIssuesQuery = useGetIssuesQuery();
  const [state, setState] = useState({
    svi: [],
    dmi: [],
    issues: [],
    notices: [],
    uploads: [],
    requiredDocumentsCount: 0,
  });

  const handleData = (data) => {
    if (data) {
      const { getIssues } = data;
      const { svi, dmi, requiredDocumentsCount, issues } = mapIssues(getIssues, members);

      setState({
        svi,
        dmi,
        issues,
        notices: getIssues?.notices,
        requiredDocumentsCount,
      });
    }
  };

  useEffect(() => {
    const getIssues = async () => {
      const { data } = await getIssuesQuery({ variables: { appID } });
      const clonedData = _.cloneDeep(data);
      handleData(clonedData);
    };

    if (appID) {
      getIssues();
    }
  }, [appID]);

  return state;
};
